import { TextInput } from "@mantine/core";
import React from "react";
import { withTranslation } from "react-i18next";

const InputField = ({
  label,
  value,
  disabled,
  icon,
  type = "text",
  placeholder,
  onChange,
  autoComplete = "off",
  form,
  validateName,
  required,
  onBlur,
  onInput,
}) => {
  return (
    <TextInput
      label={label}
      onChange={onChange}
      onInput={onInput}
      icon={
        icon && (
          <img
            src={require(`../../assets/${icon}.svg`)}
            style={{ width: "18px", height: "18px", margin: "2px 7px" }}
            alt="icon"
          />
        )
      }
      type={type}
      defaultValue={value}
      onBlur={onBlur}
      disabled={disabled}
      autoComplete={autoComplete}
      required={required}
      placeholder={placeholder}
      {...form?.getInputProps(validateName)}
      styles={{
        input: {
          border: "1px solid rgb(0,0,0,0.2)",
        },
      }}
    />
  );
};

export default withTranslation()(InputField);
